<template>
  <div class="pt-1">
    <div class="container-fluid">
      <h3 class="pl-3 mt-0 mb-3 text-title-dashboard my-2 font-weight-bold">
        Agregar nueva empresa agremiada
      </h3>
      <div class="row">
        <!-- User account details -->
        <div class="col-xl-3">
          <div class="card">
            <div class="card-header p-2 border-bottom">
              <h4 class="m-0 text-center">Datos del usuario</h4>
            </div>
            <div class="card-body row d-flex justify-content-center">
              <div class="col-xl-12 col-md-8 col-12 pt-1">
                <form class="row">
                  <div class="form-group col-12 mb-1 p-1 div-input">
                    <file-pond
                      name="test"
                      ref="filePond"
                      label-idle="Anexar logo de la empresa <br>( resolución recomendada:<br> 800x800 )"
                      accepted-file-types="image/jpeg, image/png"
                      :server="null"
                      v-model="form_company.url_image"
                      style="cursor: pointer"
                    />
                  </div>

                  <div class="form-group p-1 col-6 col-xl-12 mb-1">
                    <label for="firstName"
                      ><span class="text-danger">*</span>Nombre:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="firstName"
                      v-model="form_user.first_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>
                  <div class="form-group p-1 col-6 col-xl-12 mb-1">
                    <label for="lastName"
                      ><span class="text-danger">*</span>Apellido:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      id="lastName"
                      v-model="form_user.last_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>
                  <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-1">
                    <label for="userEmail"
                      ><span class="text-danger">*</span>Email:</label
                    >
                    <input
                      type="email"
                      class="form-control input-sm"
                      id="userEmail"
                      v-model="form_user.email"
                      required
                    />
                  </div>
                  <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-1">
                    <label for="typeStatus"
                      ><span class="text-danger">*</span>Estado del
                      Agremiado:</label
                    >
                    <Multiselect
                      v-model="form_user.id_type_user_status"
                      :options="typesUserStatus"
                      label="name"
                      placeholder="Seleccione una Opción"
                      id="typeStatus"
                    ></Multiselect>
                  </div>
                  <div class="form-group col-12 p-1 mb-1">
                    <label for="password"
                      ><span class="text-danger">*</span>contraseña:</label
                    >

                    <div class="input-group">
                      <input
                        :type="inputType"
                        class="form-control input-sm"
                        placeholder="Ingrese su contraseña"
                        aria-label="Password"
                        :class="{ 'border-danger': isPasswordMismatch }"
                        id="password"
                        v-model="form_user.password"
                        @input="checkPassword()"
                        required
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-fill btn-secondary border border-secondary p-0 pl-2 pr-2"
                          type="button"
                          @click.prevent="toggleVisibility()"
                        >
                          <i :class="passwordIconClass"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-12 p-1 mb-1">
                    <label for="password2"
                      ><span class="text-danger">*</span>confirmar
                      contraseña:</label
                    >

                    <div class="input-group mb-3">
                      <input
                        :type="inputType"
                        class="form-control input-sm"
                        placeholder="Confirme su contraseña"
                        aria-label="Confirm Password"
                        :class="{ 'border-danger': isPasswordMismatch }"
                        id="password2"
                        v-model="password2"
                        @input="checkPassword()"
                        required
                      />
                      <div class="input-group-append">
                        <button
                          class="btn btn-fill btn-secondary border border-secondary p-0 pl-2 pr-2"
                          type="button"
                          @click.prevent="toggleVisibility()"
                        >
                          <i :class="passwordIconClass"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Company user details -->
        <div class="col-xl-9">
          <div class="card">
            <div
              class="card-header border-bottom p-2 d-flex justify-content-end"
            >
              <button
                class="btn btn-primary btn-sm active"
                @click="returnUrl()"
              >
                Volver
              </button>
            </div>
            <div class="card-body">
              <!-- Conditionally render the components based on the selected view -->
              <form class="p-4 mb-5">
                <!-- DATOS GENERALES -->
                <h4 class="mt-0 mb-2">Datos Generales</h4>
                <div class="row">
                  <div class="form-group col-12 col-md-4 mb-2 p-1 div-input">
                    <label for="companyName"
                      ><span class="text-danger">*</span>Nombre de la
                      Empresa:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.company_name === ''
                      }"
                      id="companyName"
                      v-model="form_company.company_name"
                      required
                    />
                  </div>
                  <div class="form-group col-12 col-md-4 mb-2 p-1 div-input">
                    <label for="rif"
                      ><span class="text-danger">*</span>RIF:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.company_rif === ''
                      }"
                      id="rif"
                      v-model="form_company.company_rif"
                      required
                    />
                  </div>
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="socialReason">Razón Social:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.social_reason === ''
                      }"
                      id="socialReason"
                      v-model="form_company.social_reason"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="commertialDenomination"
                      >Denominación Comercial:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.commertial_denomination === ''
                      }"
                      id="commertialDenomination"
                      v-model="form_company.commertial_denomination"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="principalActivity">Actividad Principal:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.principal_activity === ''
                      }"
                      id="principalActivity"
                      v-model="form_company.principal_activity"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="sector">Sector al cual pertenece:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.sector === ''
                      }"
                      id="sector"
                      v-model="form_company.sector"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="otherAssociations"
                      >Afiliado a otras Cámaras y/o Asociaciones</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.other_associations === ''
                      }"
                      id="otherAssociations"
                      v-model="form_company.other_associations"
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="companyOfficeLocation"
                      >Dirección de la Oficina – Planta:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.company_office_location === ''
                      }"
                      id="companyOfficeLocation"
                      v-model="form_company.company_office_location"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="mainPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.main_phone === ''
                      }"
                      id="mainPhone"
                      v-model="form_company.main_phone"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="mainEmail">Correo:</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.main_email === ''
                      }"
                      id="mainEmail"
                      v-model="form_company.main_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="collectionsEmail">Correo de cobranza:</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.collections_email === ''
                      }"
                      id="collectionsEmail"
                      v-model="form_company.collections_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="website">Página Web:</label>
                    <input
                      type="url"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.website === ''
                      }"
                      id="website"
                      v-model="form_company.website"
                      required
                    />
                  </div>
                </div>

                <!-- Presidente -->
                <h4 class="mt-4">Presidente</h4>
                <div class="row">
                  <div class="form-group col-md-6 p-1 div-input">
                    <label for="presidentName">Presidente:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.president_name === ''
                      }"
                      id="presidentName"
                      v-model="form_company.president_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 p-1 div-input">
                    <label for="presidentPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.president_phone === ''
                      }"
                      id="presidentPhone"
                      v-model="form_company.president_phone"
                      required
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                    />
                  </div>

                  <div class="form-group col-md-6 p-1 div-input">
                    <label for="presidentEmail">Correo del presidente:</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.president_email === ''
                      }"
                      id="presidentEmail"
                      v-model="form_company.president_email"
                      required
                    />
                  </div>
                </div>

                <!-- CILARA Representative 1 -->
                <h4 class="mt-4">Representante legal Nro.1</h4>
                <div class="row">
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeName">Representante:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_a_full_name === '' ||
                          form_company.representative_a_full_name === null
                      }"
                      id="representativeName"
                      v-model="form_company.representative_a_full_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativePosition">Posición:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_a_position === '' ||
                          form_company.representative_a_position === null
                      }"
                      id="representativePosition"
                      v-model="form_company.representative_a_position"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativePhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_a_phone === '' ||
                          form_company.representative_a_phone === null
                      }"
                      id="representativePhone"
                      v-model="form_company.representative_a_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeEmail"
                      >Email del Representante:</label
                    >
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_a_email === '' ||
                          form_company.representative_a_email === null
                      }"
                      id="representativeEmail"
                      v-model="form_company.representative_a_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDni">Cédula:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_a_dni === '' ||
                          form_company.representative_a_dni === null
                      }"
                      id="representativeDni"
                      v-model="form_company.representative_a_dni"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>
                </div>

                <!-- CILARA Representative 2 -->
                <h4 class="mt-4">Representante legal Nro.2</h4>
                <div class="row">
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeBName">Representante:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_b_full_name === '' ||
                          form_company.representative_b_full_name === null
                      }"
                      id="representativeBName"
                      v-model="form_company.representative_b_full_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeBPosition">Posición:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_b_position === '' ||
                          form_company.representative_b_position === null
                      }"
                      id="representativeBPosition"
                      v-model="form_company.representative_b_position"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeBPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_b_phone === '' ||
                          form_company.representative_b_phone === null
                      }"
                      id="representativeBPhone"
                      v-model="form_company.representative_b_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeBEmail"
                      >Email del Representante:</label
                    >
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_b_email === '' ||
                          form_company.representative_b_email === null
                      }"
                      id="representativeBEmail"
                      v-model="form_company.representative_b_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeBDni">Cédula:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_b_dni === '' ||
                          form_company.representative_b_dni === null
                      }"
                      id="representativeBDni"
                      v-model="form_company.representative_b_dni"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>
                </div>

                <!-- CILARA Representative 3 -->
                <h4 class="mt-4">Representante legal Nro.3</h4>
                <div class="row">
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeCName">Representante:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_c_full_name === '' ||
                          form_company.representative_c_full_name === null
                      }"
                      id="representativeCName"
                      v-model="form_company.representative_c_full_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeCPosition">Posición:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_c_position === '' ||
                          form_company.representative_c_position === null
                      }"
                      id="representativeCPosition"
                      v-model="form_company.representative_c_position"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeCPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_c_phone === '' ||
                          form_company.representative_c_phone === null
                      }"
                      id="representativeCPhone"
                      v-model="form_company.representative_c_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeCEmail"
                      >Email del Representante:</label
                    >
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_c_email === '' ||
                          form_company.representative_c_email === null
                      }"
                      id="representativeCEmail"
                      v-model="form_company.representative_c_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeCDni">Cédula:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_c_dni === '' ||
                          form_company.representative_c_dni === null
                      }"
                      id="representativeCDni"
                      v-model="form_company.representative_c_dni"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>
                </div>

                <!-- CILARA Representative 4 -->
                <h4 class="mt-4">Representante legal Nro.4</h4>
                <div class="row">
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDName">Representante:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_d_full_name === '' ||
                          form_company.representative_d_full_name === null
                      }"
                      id="representativeDName"
                      v-model="form_company.representative_d_full_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDPosition">Posición:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_d_position === '' ||
                          form_company.representative_d_position === null
                      }"
                      id="representativeDPosition"
                      v-model="form_company.representative_d_position"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_d_phone === '' ||
                          form_company.representative_d_phone === null
                      }"
                      id="representativeDPhone"
                      v-model="form_company.representative_d_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDEmail"
                      >Email del Representante:</label
                    >
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_d_email === '' ||
                          form_company.representative_d_email === null
                      }"
                      id="representativeDEmail"
                      v-model="form_company.representative_d_email"
                      required
                    />
                  </div>

                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="representativeDDni">Cédula:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.representative_d_dni === '' ||
                          form_company.representative_d_dni === null
                      }"
                      id="representativeDDni"
                      v-model="form_company.representative_d_dni"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>
                </div>

                <!-- HR -->
                <h4 class="mt-4">Encargado de Recursos Humanos</h4>
                <div class="row">
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="humanResourcesName">Encargado:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.human_resources_name === ''
                      }"
                      id="humanResourcesName"
                      v-model="form_company.human_resources_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="humanResourcesPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.human_resources_phone === ''
                      }"
                      id="humanResourcesPhone"
                      v-model="form_company.human_resources_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="humanResourcesEmail">Email:</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.human_resources_email === ''
                      }"
                      id="humanResourcesEmail"
                      v-model="form_company.human_resources_email"
                      required
                    />
                  </div>
                </div>

                <!-- Administrator -->
                <h4 class="mt-4">Administrador</h4>
                <div class="row">
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="administratorName">Administrador:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.administrator_name === ''
                      }"
                      id="administratorName"
                      v-model="form_company.administrator_name"
                      oninput="this.value = this.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="administratorPhone">Teléfono:</label>
                    <input
                      type="tel"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.administrator_phone === ''
                      }"
                      id="administratorPhone"
                      v-model="form_company.administrator_phone"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="administratorEmail">Email:</label>
                    <input
                      type="email"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.administrator_email === ''
                      }"
                      id="administratorEmail"
                      v-model="form_company.administrator_email"
                      required
                    />
                  </div>
                </div>

                <!-- R.I.F. and N.I.T. Numbers -->
                <h4 class="mt-4">Información adicional</h4>
                <div class="row">
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="nitNumber">N° de N.I.T.:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.nit_number === ''
                      }"
                      id="nitNumber"
                      v-model="form_company.nit_number"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="commerceNumber">Registro de Comercio:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.commerce_number === ''
                      }"
                      id="commerceNumber"
                      v-model="form_company.commerce_number"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="postalCode">Código Postal:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.postal_code === ''
                      }"
                      id="postalCode"
                      v-model="form_company.postal_code"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="accountingCapital">Capital Contable:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.accounting_capital === ''
                      }"
                      id="accountingCapital"
                      v-model="form_company.accounting_capital"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="annualSalesVolume"
                      >Volumen de ventas al año:</label
                    >
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.annual_sales_volume === ''
                      }"
                      id="annualSalesVolume"
                      v-model="form_company.annual_sales_volume"
                      required
                    />
                  </div>
                </div>

                <!-- EMPLOYED PERSONNEL -->
                <h4 class="mt-4">Personal (Empleado)</h4>
                <div class="row">
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="professionalsHeadcount">Profesionales:</label>
                    <input
                      type="text"
                      min="0"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.professionals_headcount === '' ||
                          form_company.professionals_headcount === 0
                      }"
                      id="professionalsHeadcount"
                      v-model="form_company.professionals_headcount"
                      @input="
                        validatePositiveNumber(
                          $event,
                          'professionals_headcount'
                        )
                      "
                      @blur="validateGenderHeadcount()"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="techniciansHeadcount">Técnicos:</label>
                    <input
                      type="text"
                      min="0"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.technicians_headcount === '' ||
                          form_company.technicians_headcount === 0
                      }"
                      id="techniciansHeadcount"
                      v-model="form_company.technicians_headcount"
                      @input="
                        validatePositiveNumber($event, 'technicians_headcount')
                      "
                      @blur="validateGenderHeadcount()"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="workersHeadcount">Obreros:</label>
                    <input
                      type="text"
                      min="0"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.workers_headcount === '' ||
                          form_company.workers_headcount === 0
                      }"
                      id="workersHeadcount"
                      v-model="form_company.workers_headcount"
                      @input="
                        validatePositiveNumber($event, 'workers_headcount')
                      "
                      @blur="validateGenderHeadcount()"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="maleHeadcount">Hombres:</label>
                    <input
                      type="text"
                      min="0"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.male_headcount === '' ||
                          !genderHeadcountValidation
                      }"
                      id="maleHeadcount"
                      v-model="form_company.male_headcount"
                      @input="validatePositiveNumber($event, 'male_headcount')"
                      @blur="validateGenderHeadcount()"
                      required
                    />
                  </div>

                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="femaleHeadcount">Mujeres:</label>
                    <input
                      type="text"
                      min="0"
                      class="form-control input-sm"
                      :class="{
                        'border-danger':
                          form_company.female_headcount === '' ||
                          !genderHeadcountValidation
                      }"
                      id="femaleHeadcount"
                      v-model="form_company.female_headcount"
                      @input="
                        validatePositiveNumber($event, 'female_headcount')
                      "
                      @blur="validateGenderHeadcount()"
                      required
                    />
                  </div>
                  <div class="form-group col-md-4 mb-2 p-1 div-input">
                    <label for="femaleHeadcount">Total</label>
                    <input
                      type="text"
                      :value="calculateTotalEmployed()"
                      min="0"
                      class="form-control input-sm font-weight-bolder"
                      :class="{
                        'border-success': genderHeadcountValidation,
                        'border-danger': !genderHeadcountValidation
                      }"
                      id="totalHeadcount"
                      readonly
                    />
                  </div>
                </div>

                <h4 class="mt-4">Oferta Exportable</h4>
                <div class="row">
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="exportableCode">Código:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.exportable_code === ''
                      }"
                      id="exportableCode"
                      v-model="form_company.exportable_code"
                      required
                    />
                  </div>
                  <div class="form-group col-md-6 mb-2 p-1 div-input">
                    <label for="exportableProduct">Producto:</label>
                    <input
                      type="text"
                      class="form-control input-sm"
                      :class="{
                        'border-danger': form_company.exportable_product === ''
                      }"
                      id="exportableProduct"
                      v-model="form_company.exportable_product"
                      required
                    />
                  </div>
                </div>
                <hr />
                <div class="form-group col-12 p-1 col-md-6 col-lg-12 mb-3">
                  <div class="w-100 d-flex align-items-center">
                    <label for="deliveryService" class="m-0"
                      >¿Servicio de delivery?</label
                    >

                    <input
                      type="checkbox"
                      class="ml-3"
                      id="deliveryService"
                      v-model="form_company.has_delivery"
                      @change="
                        form_company.has_delivery = form_company.has_delivery
                          ? 1
                          : 0
                      "
                    />
                  </div>
                  <div class="row" v-if="form_company.has_delivery">
                    <div class="col-12 col-md-6">
                      <label class="mt-3">Dirección de entrega</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form_company.delivery_address"
                        :class="{
                          'border-danger':
                            form_company.delivery_address === '' ||
                            form_company.delivery_address === null
                        }"
                      />
                    </div>
                    <div class="col-12 col-md-6 d-flex align-items-end">
                      <multiselect
                        v-model="form_company.id_type_service"
                        :options="typesServices"
                        label="name"
                      ></multiselect>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="mb-3">
                  <button
                    class="btn btn-primary btn-fill float-right mr-5 mt-2"
                    type="submit"
                    @click.prevent="saveUser()"
                  >
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  components: {
    FilePond,
    Multiselect
  },
  data() {
    return {
      password2: '',
      id_user: '',
      form_user: {
        first_name: '',
        last_name: '',
        password: '',
        email: '',
        id_type_user_status: {}
      },
      form_company: {
        id_type_service: '',
        has_delivery: 0,
        delivery_address: '',
        company_name: '',
        url_image: '',
        social_reason: '',
        company_rif: '',
        commertial_denomination: '',
        main_email: '',
        principal_activity: '',
        sector: '',
        company_office_location: '',
        main_phone: '',
        collections_email: '',
        website: '',
        other_associations: '',
        president_name: '',
        president_phone: '',
        president_email: '',
        representative_d_dni: '',
        representative_d_email: '',
        representative_d_phone: '',
        representative_d_position: '',
        representative_d_full_name: '',
        representative_c_dni: '',
        representative_c_email: '',
        representative_c_phone: '',
        representative_c_position: '',
        representative_c_full_name: '',
        representative_b_dni: '',
        representative_b_email: '',
        representative_b_phone: '',
        representative_b_position: '',
        representative_b_full_name: '',
        representative_a_dni: '',
        representative_a_email: '',
        representative_a_phone: '',
        representative_a_position: '',
        representative_a_full_name: '',
        human_resources_name: '',
        human_resources_phone: '',
        human_resources_email: '',
        administrator_name: '',
        administrator_phone: '',
        administrator_email: '',
        nit_number: '',
        commerce_number: '',
        postal_code: '',
        accounting_capital: '',
        annual_sales_volume: '',
        professionals_headcount: 0,
        technicians_headcount: 0,
        workers_headcount: 0,
        male_headcount: 0,
        female_headcount: 0,
        exportable_code: '',
        exportable_product: '',
        active: false
      },
      typesUserStatus: [],
      typesServices: [],
      isPasswordMismatch: false,
      genderHeadcountValidation: false,
      inputType: 'password'
    }
  },
  methods: {
    ...mapActions(['getData', 'createData', 'updateData', 'optimizeImage']),
    loadTypesUserStatus() {
      const form = { url: 'type_user_status/all' }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesUserStatus = response.data.map((item) => ({
              id: item.id,
              name: item.name
            }))
            this.form_user.id_type_user_status = response.data[0]
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    loadTypesServices() {
      const form = { url: 'type_service/all' }
      this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.typesServices = response.data.map((item) => ({
              id: item.id,
              name: item.name
            }))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    saveUser() {
      if (!this.validateForms()) return
      if (
        this.form_company.has_delivery === 1 &&
        (this.form_company.delivery_address === '' ||
          this.form_company.delivery_address === null)
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete la dirección de entrega si marco la opción de este servicio.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (this.form_company.has_delivery == 0) {
        this.form_company.delivery_address = ''
        delete this.form_company.id_type_service
      }
      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar este usuario con la empresa agremiada?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, guardar'
      }).then((result) => {
        if (result.value) {
          const form = {
            url: 'user/save',
            data: {
              first_name: this.form_user.first_name,
              last_name: this.form_user.last_name,
              password: this.form_user.password,
              email: this.form_user.email,
              id_company: 0,
              id_type_user_status: this.form_user.id_type_user_status.id
            }
          }
          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                this.id_user = response.data.id
                this.saveCompany()
              }
              if (response.code === 409) {
                this.id_user = response.data.id
                Swal.fire({
                  title: 'Advertencia',
                  text: 'El correo electrónico ya se encuentra registrado',
                  icon: 'warning',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',
                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },
    async saveCompany() {
      const formData = new FormData()

      const appendFormData = (key, value) => {
        formData.append(key, value === null ? '' : value)
      }

      for (const key in this.form_company) {
        if (this.form_company.hasOwnProperty(key)) {
          appendFormData(key, this.form_company[key])
        }
      }
      const filePondInstance = this.$refs.filePond.getFiles()
      if (filePondInstance[0] && filePondInstance[0].file) {
        const compressedImage = await this.optimizeImage(
          filePondInstance[0].file
        )
        formData.append('url_image', compressedImage)
      }
      if (this.form_company.has_delivery === 1) {
        formData.delete('id_type_service')
        formData.append('id_type_service', this.form_company.id_type_service.id)
      }
      const form = {
        url: 'company/save',
        data: formData
      }

      this.createData(form)
        .then((response) => {
          if (response.code === 200) {
            this.updateElement(response.data.id)
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error, al crear la empresa. Puede buscar el usuario en el listado de usuarios a continuación y asociarle una empresa nuevamente.',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            this.returnUrl()
          })
        })
    },
    updateElement(id_company) {
      const form = {
        url: 'user/update',
        id: this.id_user,
        data: { id_company: id_company }
      }

      this.updateData(form)
        .then((response) => {
          if (response.code === 200) {
            Swal.fire({
              title: 'Agremiado creado correctamente.',
              icon: 'success',

              confirmButtonText: 'Aceptar'
            }).then(() => {
              this.returnUrl()
            })
          }
        })
        .catch((error) => {
          console.error(error)
          Swal.fire({
            title: 'Error',
            text: 'Ocurrió un error, intente más tarde.',
            icon: 'error',
            confirmButtonText: 'Aceptar'
          })
        })
    },
    returnUrl() {
      this.$router.go(-1)
    },
    validateForms() {
      const userFields = {
        first_name: 'Nombre',
        last_name: 'Apellido',
        password: 'Contraseña',
        email: 'Correo Electrónico',
        id_type_user_status: 'ID del Estado del Usuario'
      }

      for (const [field, name] of Object.entries(userFields)) {
        if (!this.form_user[field]) {
          this.$toaster.error(`El campo ${name} se encuentra vacio.`)
          return false
        }
      }

      if (
        this.form_company.company_name === '' ||
        this.form_company.company_name === null
      ) {
        this.$toaster.error('El nombre de la empresa no puede estar vacio.')
        return false
      }
      if (this.form_company.company_rif === '') {
        this.$toaster.error('El RIF de la empresa no puede estar vacio.')
        return false
      }
      if (this.form_user.password !== this.password2) {
        Swal.fire({
          title: 'Error',
          text: 'Las contraseñas no coinciden',
          icon: 'error',

          confirmButtonText: 'Aceptar'
        })
        return false
      }

      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
          this.form_user.email
        )
      ) {
        Swal.fire({
          title: 'Error',
          text: 'El correo electrónico no tiene un formato válido',
          icon: 'error',

          confirmButtonText: 'Aceptar'
        })
        return false
      }

      return true
    },
    checkPassword() {
      if (this.form_user.password !== this.password2) {
        this.isPasswordMismatch = true
      } else if (this.form_user.password === this.password2) {
        this.isPasswordMismatch = false
      } else if (this.password2 === '') {
        this.isPasswordMismatch = false
      }
    },
    validatePositiveNumber(event, field) {
      const value = event.target.value
      const positiveNumber = value.replace(/[^0-9]/g, '')
      this.form_company[field] = positiveNumber
    },
    calculateTotalEmployed() {
      const professionals = isNaN(
        parseInt(this.form_company.professionals_headcount)
      )
        ? 0
        : parseInt(this.form_company.professionals_headcount)
      const technicians = isNaN(
        parseInt(this.form_company.technicians_headcount)
      )
        ? 0
        : parseInt(this.form_company.technicians_headcount)
      const workers = isNaN(parseInt(this.form_company.workers_headcount))
        ? 0
        : parseInt(this.form_company.workers_headcount)
      return professionals + technicians + workers
    },
    validateGenderHeadcount() {
      const totalEmployed = this.calculateTotalEmployed()
      const maleHeadcount = parseInt(this.form_company.male_headcount) || 0
      const femaleHeadcount = parseInt(this.form_company.female_headcount) || 0
      const totalGenderHeadcount = maleHeadcount + femaleHeadcount

      if (totalGenderHeadcount !== totalEmployed) {
        this.$toaster.error(
          'La suma de hombres y mujeres debe ser igual al total de profesionales, técnicos y obreros.'
        )
        this.genderHeadcountValidation = false
      } else {
        this.genderHeadcountValidation = true
      }
    },
    toggleVisibility() {
      this.inputType = this.inputType === 'password' ? 'text' : 'password'
    }
  },
  mounted() {
    this.loadTypesUserStatus()
    this.loadTypesServices()
  },
  computed: {
    passwordIconClass() {
      return this.inputType === 'password'
        ? 'bi bi-eye-slash fs-5'
        : 'bi bi-eye-fill fs-5'
    },
    confirmPasswordIconClass() {
      return this.inputType === 'password'
        ? 'bi bi-eye-slashfs-5'
        : 'bi bi-eye-fill fs-5'
    }
  }
}
</script>
<style></style>
